// eslint-disable-next-line import/prefer-default-export
export function tryOrNull<T>(fn: () => T): T {
  try {
    return fn();
  } catch (e) {
    return null;
  }
}
